import type { DashboardDataset } from '../features/dashboard/logic/prepareDashboardData';

export type DashboardData = DashboardDataset;
type DashboardApiDataPromise = Promise<DashboardData>;

const dashboardMemoryCacheByProjectId = new Map<string, DashboardData>();
const dashboardInFlightByProjectId = new Map<string, DashboardApiDataPromise>();

export function getDashboardMemoryCache(projectId: string): DashboardData | undefined {
  return dashboardMemoryCacheByProjectId.get(projectId);
}

export function setDashboardMemoryCache(projectId: string, data: DashboardData): void {
  dashboardMemoryCacheByProjectId.set(projectId, data);
}

export function deleteDashboardMemoryCache(projectId: string): void {
  dashboardMemoryCacheByProjectId.delete(projectId);
}

export function getDashboardInFlight(projectId: string): DashboardApiDataPromise | undefined {
  return dashboardInFlightByProjectId.get(projectId);
}

export function setDashboardInFlight(
  projectId: string,
  promise: DashboardApiDataPromise,
): void {
  dashboardInFlightByProjectId.set(projectId, promise);
}

export function deleteDashboardInFlight(projectId: string): void {
  dashboardInFlightByProjectId.delete(projectId);
}

export function clearDashboardCachesForProject(projectId: string | null | undefined): void {
  if (!projectId?.trim()) {
    return;
  }
  deleteDashboardMemoryCache(projectId);
  deleteDashboardInFlight(projectId);
}

export function clearAllDashboardCaches(): void {
  dashboardMemoryCacheByProjectId.clear();
  dashboardInFlightByProjectId.clear();
}

